import { IUser } from '../auth/user.interface';
import { IBaseModel } from '../base/base-model.interface';
import { createEnumOptions } from '../shared/enum-option.interface';

export interface IProfilactic extends IBaseModel<'Profilactic'> {
  year: Date;
  checkDatePlanned?: Date;
  groupId: string;
  oltName: string;
  state: ProfilacticState;

  accessoriesCheckCompleted?: boolean;
  accessoriesCheckResult?: string;
  accessoriesPhoto?: string[];

  corrosionCheckCompleted?: boolean;
  corrosionCheckResult?: string;
  corrosionPhoto?: string[];

  externalCableSupportCheckCompleted?: boolean;
  externalCableSupportCheckResult?: string;
  externalCableSupportPhoto?: string[];

  internalCleaningCheckCompleted?: boolean;
  internalCleaningCheckResult?: string;
  internalCleaningPhoto?: string[];

  oltFanCleaningCheckCompleted?: boolean;
  oltFanCleaningCheckResult?: string;
  oltFanCleaningPhoto?: string[];

  filterReplacementCheckCompleted?: boolean;
  filterReplacementCheckResult?: string;
  filterReplacementPhoto?: string[];

  switchboardVacuumingCheckCompleted?: boolean;
  switchboardVacuumingCheckResult?: string;
  switchboardVacuumingPhoto?: string[];

  contactTighteningCheckCompleted?: boolean;
  contactTighteningCheckResult?: string;
  contactTighteningPhoto?: string[];

  surgeProtectorCheckCompleted?: boolean;
  surgeProtectorCheckResult?: string;
  surgeProtectorPhoto?: string[];

  leakProtectionCheckCompleted?: boolean;
  leakProtectionCheckResult?: string;
  leakProtectionPhoto?: string[];

  ventilationCoolingCheckCompleted?: boolean;
  ventilationCoolingCheckResult?: string;
  ventilationCoolingPhoto?: string[];

  rackExternalCheckCompleted?: boolean;
  rackExternalCheckResult?: string;
  rackExternalPhoto?: string[];

  batteryExternalCheckCompleted?: boolean;
  batteryExternalCheckResult?: string;
  batteryExternalPhoto?: string[];

  batteryLabelCheckResult?: string;
  batteryLabelPhoto?: string[];

  batteryTestStartedAt?: Date;

  voltageBeforeTest?: number;
  powerBeforeTest?: number;

  voltageAfterTest?: number;
  powerAfterTest?: number;

  voltageBeforeTestManual?: number;

  voltageAfterTestManual?: number;

  // New power test fields
  voltmeterPhoto?: string[];
  rackPhoto?: string[];
  batteriesPhoto?: string[];
  note?: string;

  assignedMasterUserId?: string;
  assignedMasterUser?: IUser;
  assignedUserId?: string;
  assignedUser?: IUser;
}

export interface IPowerTestData {
  voltmeterPhoto?: string[];
  rackPhoto?: string[];
  batteriesPhoto?: string[];
  note?: string;
}

export enum ProfilacticState {
  created = 'created',
  planned = 'planned',
  inProgress = 'inProgress',
  finished = 'finished',
  reopened = 'reopened',
}

export const profilacticStateOptions = createEnumOptions<ProfilacticState>({
  [ProfilacticState.created]: { label: 'Vytvorená', color: 'none' },
  [ProfilacticState.planned]: { label: 'Naplánovaná', color: 'primary' },
  [ProfilacticState.inProgress]: { label: 'Prebieha', color: 'info' },
  [ProfilacticState.finished]: { label: 'Dokončená', color: 'success' },
  [ProfilacticState.reopened]: { label: 'Znovu otvorená', color: 'danger' },
  _default: { label: '-' },
});
